<template>
  <div class="item B2 T3">
    <div class="name">{{item}}</div>
    <div class="time" :class="{'reset-time':isSwitchable}">到期时间</div>
  </div>
</template>

<script>
export default {
  name: 'PermissionGroupItem',
  props: {
    item: {
      type: String
    },
    isSwitchable: {
      type: Boolean
    }
  }
}
</script>

<style scoped>
.name {
  position: absolute;
  bottom: 20px;
  left: 30px;
}
.item {
  position: relative;
  height: 88px;
}
.time {
  position: absolute;
  right: 30px;
  bottom: 20px;
}
.time.reset-time {
  right: 172px;
}
</style>